module.exports = __webpack_public_path__ + "static/img/miit_icon.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/miit_icon.png
// module id = etij
// module chunks = 0